import { render, staticRenderFns } from "./ContractorDetailsEditHeader.vue?vue&type=template&id=60806525&"
import script from "./ContractorDetailsEditHeader.vue?vue&type=script&lang=js&"
export * from "./ContractorDetailsEditHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports